//Starting off from assets/js directory


//CSS Files imported only where they are needed - in headercontainer.js
//From MDBReact https://mdbootstrap.com/react/5-min-quick-start/
//import 'font-awesome/css/font-awesome.min.css';
//import 'bootstrap-css-only/css/bootstrap.min.css';


//Made new animation
import 'css/aos.css';
import AOS from 'aos';
AOS.init({
  duration : 700,
});

//React components extending default.hbs
import './App';
